import { useEffect, useMemo } from 'react';
import { applyPageSeo } from '../utils/seo';

/**
 * @param {{
 *   title?: string,
 *   description?: string,
 *   canonical?: string,
 *   image?: string,
 *   enabled?: boolean,
 *   type?: string,
 *   keywords?: string,
 *   robots?: string,
 *   siteName?: string,
 *   schema?: object | array,
 *   schemaId?: string
 * }} config
 */
export function usePageSeo(config) {
  const enabled = config?.enabled !== false;
  const title = config?.title;
  const description = config?.description;
  const canonical = config?.canonical;
  const image = config?.image;
  const type = config?.type;
  const keywords = config?.keywords;
  const robots = config?.robots;
  const siteName = config?.siteName;
  const schemaId = config?.schemaId;

  // Memoize schema stringification so deep equality doesn't trigger unnecessary re-renders
  const schemaStr = useMemo(() => {
    if (!config?.schema) return null;
    try {
      return typeof config.schema === 'string' ? config.schema : JSON.stringify(config.schema);
    } catch {
      return null;
    }
  }, [config?.schema]);

  useEffect(() => {
    if (!enabled) return undefined;
    if (!title && !description && !schemaStr) return undefined;

    const schemaObj = schemaStr ? JSON.parse(schemaStr) : undefined;
    return applyPageSeo({
      title,
      description,
      canonical,
      image,
      type,
      keywords,
      robots,
      siteName,
      schema: schemaObj,
      schemaId
    });
  }, [enabled, title, description, canonical, image, type, keywords, robots, siteName, schemaStr, schemaId]);
}

